export enum FilterLabels {
  equals = <any>'Equals',
  notEqual = <any>'Not Equal',
  lessThan = <any>'Less Than',
  lessThanOrEqual = <any>'Less Than or Equal',
  greaterThan = <any>'Greater Than',
  greaterThanOrEqual = <any>'Greater Than or Equal',
  inRange = <any>'In Range'
}
